<template>
    <div>
        <vs-popup class="holamundo" icon-close="X" :title="this.title" :active.sync="active">

            <form action="/recruiting-applicants-hire-applicant" method="POST">
                <input type="hidden" name="_token" :value="csrf">
                <input type="hidden" name="newPerson[applicant_id]" :value="itemId">

                <div class="row">
                    <div class="form-group col-12 col-lg-6">
                        <label>{{__('forms.RecruitingApplicant.CompanyEmail')}}</label>
                        <input class="form-control" name="newPerson[email]" required type="text" >
                    </div>
                    <div v-if="is_required_phone_number" class="form-group col-12 col-lg-6">
                        <label>{{__('forms.People.phone_number')}}</label>
                        <input class="form-control" name="newPerson[phone_number]" required type="text">
                    </div>
                    <div class="form-group col-12 col-lg-6">
                        <label>{{__('forms.People.tax_code')}}</label>
                        <input class="form-control" name="newPerson[tax_code]" required type="text" v-model="taxCode">
                    </div>
                    <div class="form-group col-12 col-lg-6">
                        <label>{{__('forms.People.badge_number')}}</label>
                        <input class="form-control" name="newPerson[badge_number]" type="text" >
                    </div>
                    <div class="form-group col-12 col-lg-6">
                        <label>{{__('forms.PeopleRoles.role')}}</label>
                        <select class="form-control" name="newPerson[role_id]" v-model="newRole" required="required">
                            <option value="" disabled>...</option>
                            <option v-for="role in roles" :value="role.id" :key="role.id">{{ role.identifiable_name }}</option>
                        </select>
                    </div>
                    <div class="form-group col-12 col-lg-6">
                        <label>{{__('forms.Person.responsible')}}</label>
                        <select class="form-control" name="newPerson[responsible_id]" v-model="responsibleId" @change="getRoles()" required="required">
                            <option value="" disabled>...</option>
                            <option v-for="person in people" :value="person.id" :key="person.id">{{ person.identifiable_name }}</option>
                        </select>
                    </div>
                    <div class="form-group col-12 col-lg-6">
                        <label>{{__('forms.PeopleRoles.responsible_role')}}</label>
                        <select class="form-control" name="newPerson[responsible_role_id]" v-model="newResponsibleRole" required="required">
                            <option value="" disabled>...</option>
                            <option v-for="responsibleRole in responsibleRoles" :value="responsibleRole.id" :key="responsibleRole.id">{{ responsibleRole.name }}</option>
                        </select>
                    </div>
                    <div class="form-group col-12 col-lg-6">
                        <label>{{__('forms.PeopleRoles.fte')}}</label>
                        <input class="form-control" name="newPerson[fte]" type="number" :value="fte" >
                    </div>
                    <div class="form-group col-12 col-lg-6">
                        <label>{{__('forms.People.headquarter')}}</label>
                        <select class="form-control" name="newPerson[headquarter_id]" v-model="headquarter" required="required">
                        <option value="" disabled>...</option>
                        <option v-for="headquarter in headquarters" :value="headquarter.id" :key="headquarter.id">{{ headquarter.identifiable_name }}</option>
                        </select>
                    </div>
                    <div class="form-group col-12 col-lg-6">
                        <label>{{__('forms.People.hire_date')}}</label>
                        <vue-datepicker
                            input_class="form-control"
                            input_name="newPerson[start_date]"
                            :input_value="today"
                            required="required"
                        ></vue-datepicker>
                    </div>
                </div>

                <hr class="my-4">
 
                <div class="form-buttons clear">
                    <button type="submit" class="btn btn--green"><i class="fas fa-user-plus"></i> {{__('forms.RecruitingApplicant.hire')}}</button>
                </div>
            </form>
        </vs-popup>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                value: null,
                editing: false,
                active: false,
                action: "",
                title: this.__('forms.RecruitingApplicant.hiringAdditionalInfo'),
                itemId: null,
                taxCode : null,
                headquarter : null,
                fte   : 100,
                today : new Date().toJSON().slice(0,10),
                parameters: {},
                headquarters: {},
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                
                newRole : -1,
                newResponsibleRole: -1,
                responsibleId: -1,
                responsibleRoles: [], 
            }
        },
        methods: {
            // Open modal
            toggle(item_id, editing, attributes) {            
                axios.get("/applicant-get-info-person/"+item_id+"/applicant").then((response) => {
                    this.taxCode = response.data.tax_code;
                    this.headquarters = response.data.headquarters;
                }).catch(function(error){
                    alert(error);
                });
                
                this.active = true;
                this.itemId = item_id;
            },
            getRoles() {
                axios.get("/people-roles-get-roles-by-people/"+this.responsibleId+"/person")
                    .then((response) => {            
                        this.responsibleRoles = response.data;
                    });
            }
        },
        mounted() {
            this.newRole = this.role;
            this.newResponsibleRole = this.responsibleRole;
        },
        props: {
            people: {
                type: Array,
                required: true
            },
            roles: {
                type: Array,
                required: true
            },
            is_visible_on_boarding: {
                type: Boolean,
                required: true
            },
            is_required_phone_number: {
                type: Boolean,
                required: true
            },
            role:{
                type: Number,
                required : false
            },
            responsibleRole:{
                type: Number,
                required : false
            },
        },
        computed: {
            computedNewPerson: {
                get() {
                    return this.responsibleId;
                },
            },
        }
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .con-vs-popup {
    z-index: 1000;
  }
</style>
